import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ui/ErrorBoundary";
import NoEncontrado from "components/ui/NoEncontrado";
import AppShell from "components/AppShell";
import Inspeccion from "./pages/inspeccion";
import Estado from "./pages/estado";
import Inspecciones from "./pages/inspecciones";
import Hallazgos from "./pages/hallazgos";
import Reportes from "./pages/reportes";
import Arboles from "./pages/arboles";
import ArbolFicha from "./pages/arboles/Ficha";
import Cables from "./pages/cables";
import CableFicha from "./pages/cables/Ficha";
import InspeccionDetalle from "./pages/inspeccion-detalle";
import { useAuth } from "./contexts/AuthContext";
import { esRutaInspeccion } from "./lib/rutas";

// La cuenta técnica del ingreso con PIN solo sirve para inspeccionar: cualquier
// otra ruta (incluidas /inspecciones y /estado) la manda a /inspeccion. El
// resto de usuarios no se ve afectado. Es una comodidad de navegación; el
// límite real lo pone RLS en la base.
const GuardaPin = ({ children }) => {
  const { esPin } = useAuth();
  const { pathname } = useLocation();
  if (esPin && !esRutaInspeccion(pathname)) return <Navigate to="/inspeccion" replace />;
  return children;
};

// La raíz: quien inspecciona (PIN o la tablet del kiosko) va al asistente;
// administración (SSO) va a Estado.
export const RootRedirect = () => {
  const { esPin, esKiosco } = useAuth();
  return <Navigate to={esPin || esKiosco ? "/inspeccion" : "/estado"} replace />;
};

// Rutas viejas que pueden estar guardadas en favoritos: conservan la consulta.
const Redirigir = ({ a }) => {
  const { search } = useLocation();
  return <Navigate to={`${a}${search}`} replace />;
};

// 404 y ErrorBoundary de shared/vls-ui (auditoría de UI 2026-10-20, Lote 2), en
// español y con Volver al hub. "Volver al inicio" pasa por la raíz, que manda a
// cada quien a su pantalla. El error de una pantalla se limpia al cambiar de ruta.
// Dentro de AppShell, para que el 404 lleve el mismo encabezado común que el
// resto de pantallas (convención de shared, 2026-10-20).
const PaginaNoEncontrada = () => {
  const navigate = useNavigate();
  return (
    <AppShell>
      <NoEncontrado pantallaCompleta={false} onInicio={() => navigate("/")} />
    </AppShell>
  );
};

const ConReinicio = ({ children }) => {
  const { pathname } = useLocation();
  return <ErrorBoundary resetKeys={[pathname]}>{children}</ErrorBoundary>;
};

const Routes = () => (
  <BrowserRouter>
    <ConReinicio>
      <ScrollToTop />
      <GuardaPin>
        <RouterRoutes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/inspeccion/*" element={<Inspeccion />} />
          <Route path="/estado" element={<Estado />} />
          <Route path="/inspecciones" element={<Inspecciones />} />
          <Route path="/inspecciones/:id" element={<InspeccionDetalle />} />
          <Route path="/hallazgos" element={<Hallazgos />} />
          <Route path="/cables" element={<Cables />} />
          <Route path="/cables/:id" element={<CableFicha />} />
          <Route path="/arboles" element={<Arboles />} />
          <Route path="/arboles/:id" element={<ArbolFicha />} />
          <Route path="/reportes" element={<Reportes />} />
          <Route path="/dashboard" element={<Redirigir a="/inspecciones" />} />
          <Route path="/incidentes" element={<Redirigir a="/hallazgos" />} />
          <Route path="*" element={<PaginaNoEncontrada />} />
        </RouterRoutes>
      </GuardaPin>
    </ConReinicio>
  </BrowserRouter>
);
export default Routes;
